import { useAtomValue } from 'jotai';

import { userInstanceAtom } from '@/atoms/userDetails';
import { EMPLOYEE_PORTAL_ACCESS_PERMISSIONS } from '@/constants/Permission';
import { useUserPermissions } from '@/hooks/api/useUserPermissions';

/**
 * Whether the reader may open My portal (#17107): they are the company administrator, or their
 * role holds "Access the employee portal", or they manage performance for their team or for every
 * department. The administrator is let in on the session alone, as the Pro gate does, so a role row
 * the release step has not written yet never locks them out.
 *
 * `undefined` while the permissions are still loading, so a caller renders nothing rather than the
 * wrong state; `false` when the read fails, so a way into the portal is never offered on a guess.
 */
export const useEmployeePortalAccess = (): boolean | undefined => {
    const { isAdminUser } = useAtomValue(userInstanceAtom);
    const { permissions, isError } = useUserPermissions();

    if (isAdminUser) {
        return true;
    }

    if (isError) {
        return false;
    }

    if (permissions === undefined) {
        return undefined;
    }

    return EMPLOYEE_PORTAL_ACCESS_PERMISSIONS.some((permission) => permissions[permission]);
};
